import React, { forwardRef} from 'react';
import styled from 'styled-components';
import IEditableProps from 'src/utilities/IEditableProps';
import IStyledProps from 'src/utilities/IStyledProps';
import classNames from 'classnames';
import { getReplacedContent, parseHTML } from "../../utilities/markdown";

export interface ICaptionProps extends IEditableProps, IStyledProps {
   captionBody:string|object;
}

export default styled(forwardRef(({className, editorClassObj, cmsId, captionBody}: ICaptionProps, ref: any) => {

   return (
      <div className={classNames('blur text-white text-left', className, editorClassObj)} ref={ref} data-id={cmsId}>
         {typeof captionBody === 'string' ? parseHTML(captionBody, 'Caption') : getReplacedContent(captionBody)}
      </div>
   )
}))`
   border-width: 0;
   margin: auto 0 0;
   padding: 0.667rem 1.278rem;
   background-color: rgba(255, 255, 255, 0.1);
   z-index: 1;
   width: 100%;

   p {
      margin: 0;
   }

`